import React from "react";
import { useMetaContext } from "../../provider/MetaProvider";
import { useParksContext } from "../../provider/ParksProvider";
import { useMasterContext } from "../../provider/MasterProvider";
import AccommodationFilterSkeleton from "../common/Skeleton/park/filter/AccommodationFilterSkeleton";
import { common } from "Data/common";
const WEB_FILTER = common?.ALL_PARKS;


const ParksFilter = () => { 
  const { metaLoading, accommodation } = useMetaContext();
  const { bonusExperience } = useMasterContext();
  const { filters, parksDispatch } = useParksContext();

  

  const updateFilter = (name, value) => {
    parksDispatch({ type: "SET_PAGE_INDEX", payload: 1 });
    parksDispatch({
      type: "UPDATE_PARKS_FILTER",
      payload: { [name]: value },
    });
  };

  return (
    <>
     
        <form action="/park" id="sideSearchform">
          <div className="filter-wrapper d-lg-block d-none sticky-sidebar">
            <div className="title_top pb-4 ms-2">
              <h4>{WEB_FILTER?.SELECTED_FILTER}</h4>
            </div>
            <div className="title_filter mb-4 ms-2">
              <h6>{WEB_FILTER?.ACCOMMODATION}</h6>
              <div className="input_check ">
                {(Array.isArray(accommodation) && accommodation?.length > 0) ? (
                  accommodation?.map(accomo => (
                    <div className="d-flex align-items-center pt-1" key={accomo.value}>
                      <input
                        id={`accomodation-${accomo.value}`}
                        type="checkbox"
                        className="type checkbox_design me-3"
                        name="accomodation_id"
                        value={accomo.value}
                        checked={Array.isArray(filters?.accomodation_id) && filters.accomodation_id.includes(accomo.value)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const current = filters?.accomodation_id || [];
                          const newValues = checked
                            ? [...current, accomo.value]
                            : current.filter(v => v !== accomo.value);
                          updateFilter("accomodation_id", newValues);
                        }}
                      />
                      <label htmlFor={`accomodation-${accomo.value}`}>{accomo.label}</label>
                    </div>
                  )))
                  : metaLoading ? (
                    <AccommodationFilterSkeleton count={3}/>
                  )
                    : (
                      <p>{WEB_FILTER?.NO_FILTER}</p>
                    )}
              </div>
            </div>
            <div className="title_filter mb-4 ms-2">
              <h6>{WEB_FILTER?.BONUS_EXPERIENCE}</h6>
              <div className="input_check ">
                {(Array.isArray(bonusExperience) && bonusExperience?.length > 0) ? (
                  bonusExperience.map(bonusExp => (
                    <div className="d-flex align-items-center pt-1" key={bonusExp.value}>
                      <input
                        id={`bonus-${bonusExp.value}`}
                        type="checkbox"
                        className="type checkbox_design me-3"
                        name="bonus_experience_id"
                        value={bonusExp.value}
                        checked={Array.isArray(filters?.bonus_experience_id) && filters.bonus_experience_id.includes(bonusExp.value)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const current = filters?.bonus_experience_id || [];
                          const newValues = checked
                            ? [...current, bonusExp.value]
                            : current.filter(v => v !== bonusExp.value);
                          updateFilter("bonus_experience_id", newValues);
                        }}
                      />
                      <label htmlFor={`bonus-${bonusExp.value}`}>{bonusExp.label}</label>
                    </div>
                  ))) : metaLoading ? (
                    <AccommodationFilterSkeleton count={4}/>
                  )
                  : (
                    <p>{WEB_FILTER?.NO_FILTER}</p>
                  )}
              </div>
            </div>
          </div>
        </form>
     
    </>
  );
}

export default ParksFilter;
